import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ButtonBadge = (props: SvgProps) => (
  <Svg width={36} height={15} viewBox="0 0 36 15" fill="none" {...props}>
    <rect
      x="2.88184"
      y="2.15463"
      width="30.75"
      height="12"
      rx="5.22893"
      fill="url(#btnbadge_paint0)"
    />
    <rect
      x="2.88184"
      y="2.15463"
      width="30.75"
      height="10.4579"
      rx="5.22893"
      fill="url(#btnbadge_paint1)"
    />
    <path
      d="M12.6832 8.99451V6.3931H14.1698C14.3063 6.3931 14.4289 6.41965 14.5376 6.47274C14.6488 6.52583 14.7361 6.60041 14.7993 6.69647C14.8625 6.79254 14.8941 6.90504 14.8941 7.03397C14.8941 7.13762 14.8751 7.2299 14.8372 7.3108C14.7993 7.3917 14.7474 7.45869 14.6817 7.51178C14.6185 7.56487 14.5464 7.60406 14.4655 7.62934V7.64451C14.5616 7.66473 14.6463 7.70265 14.7196 7.75827C14.7955 7.81389 14.8549 7.88594 14.8979 7.97442C14.9434 8.06038 14.9661 8.16277 14.9661 8.28159C14.9661 8.43833 14.9295 8.56979 14.8561 8.67597C14.7854 8.78215 14.6905 8.86178 14.5717 8.91487C14.4529 8.96796 14.3202 8.99451 14.1736 8.99451H12.6832ZM13.2483 8.53187H14.0636C14.1571 8.53187 14.233 8.50532 14.2911 8.45223C14.3518 8.39914 14.3821 8.31698 14.3821 8.20574C14.3821 8.14001 14.3695 8.08313 14.3442 8.0351C14.3189 7.98706 14.281 7.95041 14.2304 7.92512C14.1799 7.89732 14.1154 7.88341 14.037 7.88341H13.2483V8.53187ZM13.2483 7.44352H13.9991C14.0674 7.44352 14.1243 7.43088 14.1698 7.4056C14.2178 7.37779 14.2532 7.3424 14.2759 7.29942C14.3012 7.25392 14.3139 7.20209 14.3139 7.14394C14.3139 7.04535 14.2861 6.97077 14.2304 6.92021C14.1773 6.86965 14.1066 6.84437 14.0181 6.84437H13.2483V7.44352ZM16.0191 9.04001C15.8169 9.04001 15.6563 8.98439 15.5375 8.87316C15.4187 8.76192 15.3593 8.58243 15.3593 8.33468V6.99984H15.8864V8.24746C15.8864 8.31319 15.894 8.3688 15.9091 8.41431C15.9243 8.45729 15.9458 8.49268 15.9736 8.52049C16.0039 8.5483 16.0406 8.56852 16.0836 8.58116C16.1266 8.5938 16.1746 8.60012 16.2277 8.60012C16.306 8.60012 16.3768 8.58116 16.44 8.54324C16.5032 8.50532 16.5525 8.4535 16.5879 8.38777C16.6233 8.31951 16.641 8.24366 16.641 8.16024V6.99984H17.1681V8.99451H16.7358L16.6979 8.72147H16.6714C16.6233 8.78468 16.5664 8.84029 16.5007 8.88833C16.4375 8.93636 16.3655 8.97302 16.2846 8.9983C16.2037 9.02611 16.1152 9.04001 16.0191 9.04001ZM18.2473 9.04001C18.1209 9.04001 18.0185 9.01726 17.9402 8.97175C17.8618 8.92625 17.8049 8.86557 17.7695 8.78973C17.7341 8.71136 17.7164 8.62541 17.7164 8.53187V7.4056H17.4699V6.99984H17.7354L17.834 6.43102H18.2435V6.99984H18.6076V7.4056H18.2435V8.44465C18.2435 8.50532 18.2574 8.55209 18.2852 8.58496C18.313 8.61529 18.3586 8.63046 18.4218 8.63046H18.6076V8.97934C18.5772 8.98945 18.5418 8.9983 18.5014 9.00588C18.4609 9.016 18.418 9.02358 18.3725 9.02864C18.3269 9.03622 18.2852 9.04001 18.2473 9.04001ZM19.5435 9.04001C19.417 9.04001 19.3147 9.01726 19.2363 8.97175C19.1579 8.92625 19.101 8.86557 19.0656 8.78973C19.0303 8.71136 19.0126 8.62541 19.0126 8.53187V7.4056H18.7661V6.99984H19.0315L19.1301 6.43102H19.5397V6.99984H19.9037V7.4056H19.5397V8.44465C19.5397 8.50532 19.5536 8.55209 19.5814 8.58496C19.6092 8.61529 19.6547 8.63046 19.7179 8.63046H19.9037V8.97934C19.8734 8.98945 19.838 8.9983 19.7975 9.00588C19.7571 9.016 19.7141 9.02358 19.6686 9.02864C19.6231 9.03622 19.5814 9.04001 19.5435 9.04001ZM21.1619 9.04001C20.9445 9.04001 20.76 9.00336 20.6083 8.93004C20.4566 8.8542 20.3416 8.73917 20.2632 8.58496C20.1848 8.42821 20.1456 8.23229 20.1456 7.99718C20.1456 7.75701 20.1848 7.56108 20.2632 7.40939C20.3416 7.25518 20.4566 7.14142 20.6083 7.0681C20.76 6.99226 20.9445 6.95434 21.1619 6.95434C21.3844 6.95434 21.5702 6.99226 21.7194 7.0681C21.8711 7.14142 21.9861 7.25518 22.0645 7.40939C22.1428 7.56108 22.182 7.75701 22.182 7.99718C22.182 8.23229 22.1428 8.42821 22.0645 8.58496C21.9861 8.73917 21.8711 8.8542 21.7194 8.93004C21.5702 9.00336 21.3844 9.04001 21.1619 9.04001ZM21.1619 8.63046C21.2782 8.63046 21.3705 8.60897 21.4388 8.566C21.5095 8.52302 21.5614 8.45729 21.5942 8.3688C21.6271 8.28032 21.6435 8.17161 21.6435 8.04268V7.95167C21.6435 7.82274 21.6271 7.71403 21.5942 7.62555C21.5614 7.53706 21.5095 7.47133 21.4388 7.42836C21.3705 7.38285 21.2782 7.3601 21.1619 7.3601C21.0482 7.3601 20.9559 7.38285 20.8851 7.42836C20.8168 7.47133 20.7663 7.53706 20.7334 7.62555C20.7005 7.71403 20.6841 7.82274 20.6841 7.95167V8.04268C20.6841 8.17161 20.7005 8.28032 20.7334 8.3688C20.7663 8.45729 20.8168 8.52302 20.8851 8.566C20.9559 8.60897 21.0482 8.63046 21.1619 8.63046ZM22.5699 8.99451V6.99984H23.006L23.0477 7.27288H23.0742C23.1197 7.20715 23.1741 7.15027 23.2373 7.10223C23.303 7.0542 23.3763 7.01754 23.4572 6.99226C23.5381 6.96698 23.6266 6.95434 23.7227 6.95434C23.8541 6.95434 23.9692 6.97835 24.0678 7.02639C24.1664 7.07442 24.2422 7.15027 24.2953 7.25392C24.3509 7.35757 24.3787 7.49282 24.3787 7.65968V8.99451H23.8516V7.7431C23.8516 7.6799 23.844 7.62681 23.8289 7.58383C23.8137 7.53833 23.7909 7.50167 23.7606 7.47386C23.7328 7.44352 23.6974 7.42203 23.6544 7.40939C23.6114 7.39675 23.5634 7.39043 23.5103 7.39043C23.432 7.39043 23.3612 7.40939 23.298 7.44732C23.2348 7.48524 23.1855 7.53706 23.1501 7.60279C23.1147 7.66852 23.097 7.74437 23.097 7.83032V8.99451H22.5699Z"
      fill="#005436"
    />
    <g opacity="0.5">
      <path
        d="M30.0548 4.21503C28.8514 3.26784 25.9719 3.30632 24.6826 3.44396L31.3989 9.38498C32.7674 6.90745 31.0731 4.90604 30.0548 4.21503Z"
        fill="url(#btnbadge_paint3)"
      />
    </g>
    <g opacity="0.5">
      <path
        d="M5.22742 10.3161C6.43079 11.2633 9.31028 11.2248 10.5996 11.0872L3.88332 5.14618C2.51478 7.62371 4.20916 9.62512 5.22742 10.3161Z"
        fill="url(#btnbadge_paint4)"
      />
    </g>
    <path
      d="M7.17969 2.63495H29.3426"
      stroke="white"
      strokeWidth="0.269663"
      strokeOpacity="0.5"
    />
    <path
      d="M7.17969 12.3765H29.3426"
      stroke="#1400FF"
      strokeOpacity="0.15"
      strokeWidth="0.269663"
    />
    <defs>
      <linearGradient
        id="btnbadge_paint0"
        x1="18.2568"
        y1="2.15463"
        x2="18.2568"
        y2="14.1546"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEB80" />
        <stop offset="1" stopColor="#B7FEAE" />
      </linearGradient>
      <linearGradient
        id="btnbadge_paint1"
        x1="8.35515"
        y1="1.62795"
        x2="32.2414"
        y2="10.7417"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEB80" />
        <stop offset="0.322115" stopColor="#B7FEAE" />
        <stop offset="0.75" stopColor="#FFEB80" />
        <stop offset="0.971154" stopColor="#B7FEAE" />
      </linearGradient>
      <linearGradient
        id="btnbadge_paint3"
        x1="28.2969"
        y1="3.37079"
        x2="33.0632"
        y2="8.22627"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEB80" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="btnbadge_paint4"
        x1="6.98531"
        y1="11.1604"
        x2="2.21899"
        y2="6.30489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#25FBD3" />
        <stop offset="1" stopColor="#03AB8C" />
      </linearGradient>
    </defs>
  </Svg>
);

export default ButtonBadge;
